var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cancellation-policy" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n        Buchen bei uns lohnt sich!\n    ")
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "tick-li" }, [
        _c("li", [
          _c("span", { staticClass: "li-title" }, [
            _vm._v("Direkt und einfach buchen")
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "Sie können Ihr Ferienhaus 24h direkt, sicher und bequem buchen\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("span", { staticClass: "li-title" }, [_vm._v("Bester Preis")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "Über unsere Homepage buchen Sie unsere Ferienhäuser zum günstigsten Preis\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("span", { staticClass: "li-title" }, [_vm._v("Top Service")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "Wir sind für Sie da. Unser Team unterstützt Sie gerne und schnell bei Fragen\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("span", { staticClass: "li-title" }, [_vm._v("Direkte Auswahl")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "Nur auf unserer Webseite haben Sie immer die direkte Auswahl über alle verfügbaren Häuser\n        "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }